import { StarScoreCard } from '@/components/feedback/StarScoreCard'
import type { StarScores } from '@/types/interview'

const SAMPLE_SCORES: StarScores = {
  situation: 3.8,
  task: 3.2,
  action: 4.4,
  result: 2.6,
  overall: 3.7,
  competencyScore: 3.7,
}

const SAMPLE_STRENGTHS = [
  'Action section is specific, first-person, and sequenced clearly',
  'Situation provides enough context without over-explaining',
]

const SAMPLE_IMPROVEMENTS = [
  'Result needs a quantified outcome — "the project shipped" is not enough',
  "Task section blurs your personal accountability with the team's",
]

const SAMPLE_TIP =
  'Close with a concrete metric: deploy frequency, error rate, or user impact. One number turns a 2.6 Result into a 4.0+.'

export function LoginPagePreview() {
  return (
    <div className="flex flex-col justify-center h-full px-8 xl:px-12 py-10 space-y-5 border-r border-border bg-muted/20 overflow-y-auto">
      <div className="space-y-0.5">
        <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground">
          Sample Report
        </p>
        <p className="text-sm font-semibold">Software Engineer · Mid level</p>
        <p className="text-xs text-muted-foreground">Leadership · "Tell me about a time…"</p>
      </div>

      <StarScoreCard scores={SAMPLE_SCORES} />

      <div className="rounded-xl border border-border bg-background divide-y divide-border overflow-hidden text-sm">
        <div className="px-4 py-3 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Strengths
          </p>
          <ul className="space-y-1">
            {SAMPLE_STRENGTHS.map((s) => (
              <li key={s} className="flex items-start gap-2 text-xs text-foreground">
                <span className="mt-0.5 text-emerald-500 flex-shrink-0">✓</span>
                {s}
              </li>
            ))}
          </ul>
        </div>

        <div className="px-4 py-3 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Areas to improve
          </p>
          <ul className="space-y-1">
            {SAMPLE_IMPROVEMENTS.map((s) => (
              <li key={s} className="flex items-start gap-2 text-xs text-foreground">
                <span className="mt-0.5 text-amber-500 flex-shrink-0">→</span>
                {s}
              </li>
            ))}
          </ul>
        </div>

        <div className="px-4 py-3 space-y-1">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Tip for next time
          </p>
          <p className="text-xs text-muted-foreground leading-relaxed">{SAMPLE_TIP}</p>
        </div>
      </div>

      <p className="text-xs text-muted-foreground text-center">
        Your feedback will look exactly like this.{' '}
        <a
          href="/sample-reports"
          className="text-primary underline underline-offset-2 hover:opacity-80 transition-opacity"
        >
          See more examples →
        </a>
      </p>
    </div>
  )
}
